import baseService from '../../services/base';

/**
 * Carrega a capa de um pilar e devolve um object URL local.
 *
 * POR QUE ISTO NÃO É UMA URL DIRETA
 *   `GET /image/:chave` passa pelo guard global da API e exige Bearer token. Uma
 *   tag `<img src="{api}/image/...">` é requisição do NAVEGADOR: ela não passa
 *   pelo interceptor do axios, não leva Authorization e volta **401**. O
 *   resultado na tela é ícone de imagem quebrada, sem erro visível no console da
 *   aplicação — só no network.
 *
 *   Por isso a capa é BUSCADA pelo baseService (que carrega o interceptor) como
 *   blob, e virada em object URL local. É a mesma abordagem que a tela de
 *   Pilares já usava.
 *
 * POR QUE ESTA FUNÇÃO EXISTE EM VEZ DE CADA TELA RESOLVER
 *   O conhecimento acima já estava escrito em pages/pillars/index.jsx e mesmo
 *   assim a EG-42 introduziu `<Image src={baseUrl + '/image/' + chave}>` em
 *   IdentidadeDoPilar — o defeito 401 que este arquivo conserta. Comentário num
 *   arquivo não protege outro arquivo. Ponto único protege.
 *
 * QUEM CHAMA É RESPONSÁVEL POR LIBERAR
 *   Object URL só é coletado quando alguém chama URL.revokeObjectURL. Em
 *   componente, isso é o cleanup do useEffect: sem ele cada troca de pilar deixa
 *   um blob preso na memória da aba.
 *
 * @param {string|null|undefined} chave caminho do bucket, ex.: `pillar/abc.png`
 * @returns {Promise<string|null>} object URL, ou null se não houver capa
 */
export const carregarCapaDoPilar = async (chave) => {
  // Só caminho do bucket vira requisição. Sem esta guarda, um valor que já é URL
  // absoluta (ou lixo) produziria `/image/https://...`, que responde erro e
  // deixa a capa quebrada em silêncio.
  if (!chave || !chave.startsWith('pillar/')) return null;

  try {
    const resposta = await baseService.get(
      `/image/${chave.replace('pillar/', 'pillar%2F')}`,
      { responseType: 'blob' }
    );
    return URL.createObjectURL(resposta.data);
  } catch {
    // Capa ausente ou ilegível não é erro de fluxo: a tela mostra o estado
    // "Sem imagem", que é o caso normal na maioria dos pilares do catálogo.
    return null;
  }
};
